const BigShapeTopRight = "../../assets/backgrounds/background-big-shape.svg";
const BigShapeBottomLeft =
  "../../assets/backgrounds/background-big-shape-left.svg";
export { BigShapeTopRight, BigShapeBottomLeft };
